// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Footer_fadeIn__GB4Q4","fadein":"Footer_fadein__35lk1"};